import {
  SparklesIcon,
  PencilIcon,
  LinkBrokenIcon,
  TwitterIcon,
  TiktokIcon,
  InstagramIcon,
  WarningIcon,
  TextRephraseIcon,
} from '@buffer-mono/popcorn'

import styles from './AllSlides.module.css'

export function Slide1(): JSX.Element {
  return (
    <>
      <h4 className={styles.title}>Hi, I'm your assistant 👋</h4>
      <div className={styles.contentWrapper}>
        <h5 className={styles.subtitle}>I can help you:</h5>
        <ul>
          <li>
            <PencilIcon className={styles.listIcon} />
            Write about any topic
          </li>
          <li>
            <TextRephraseIcon className={styles.listIcon} />
            Revise content
          </li>
          <li>
            <SparklesIcon className={styles.listIcon} />
            Repurpose posts across networks
          </li>
        </ul>
      </div>
    </>
  )
}

export function Slide2(): JSX.Element {
  return (
    <>
      <h4 className={styles.title}>Useful things to know about me👇</h4>
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <TwitterIcon size="large" />
          <TiktokIcon size="large" />
          <InstagramIcon size="large" />
        </div>
        <p className={styles.contentText}>
          I understand the channel you're posting to and will tailor my
          suggestions for that audience.
        </p>
      </div>
    </>
  )
}

export function Slide3(): JSX.Element {
  return (
    <>
      <h4 className={styles.title}>Useful things to know about me👇</h4>
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <LinkBrokenIcon size="large" />
        </div>
        <p className={styles.contentText}>
          I don't have internet access and can't view any URLs you share.
        </p>
      </div>
    </>
  )
}

export function Slide4(): JSX.Element {
  return (
    <>
      <h4 className={styles.title}>Useful things to know about me👇</h4>
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <WarningIcon size="large" />
        </div>
        <p className={styles.contentText}>
          I sometimes, unintentionally, can share wrong or offensive information
          and have limited knowledge of events after Oct 2023.
        </p>
      </div>
    </>
  )
}
